import React from "react";
import ZenSingleChart from "../components/ManagerDashboard/ZenSampleChart";
import LineReport from "../components/Reports/LineReport";
import LinePerformance from "../pages/LinePerformance";
import Lineperformancecompl from "../pages/Lineperformancecompl";

import ReportTom from "../pages/ReportTom";
import DynamicStable from "../pages/DynamicStable";
import TaioPage from "../pages/TaioPage";
// import ZenSingleChart from "../components/ManagerDashboard/ZenSingleChart";
import SbLineDoh from "../components/ScanBan/SbLineDoh";
import SbLineHeizunkaGantt from "../components/ScanBan/SbLineHeizunkaGantt";
import SbLineLandingPage from "../components/ScanBan/SbLineLandingPage";
import SbPartInpOpWaterfall from "../components/ScanBan/SbPartInpOpWaterfall";
import SbPartLandingPage from "../components/ScanBan/SbPartLandingPage";
import SbPartScheduleVariation from "../components/ScanBan/SbPartScheduleVariation";
import SbPartStockMovement from "../components/ScanBan/SbPartStockMovement";
import SbPlantLandingPage from "../components/ScanBan/SbPlantLandingPage";
import SbPlantRogItr from "../components/ScanBan/SbPlantRogItr";
import SbPlantTopVariationParts from "../components/ScanBan/SbPlantTopVariationParts";
import ZenContainerSingleChart from "../components/ManagerDashboard/Common/Containers/ZenContainerSingleChart";
import SnippetLinePerformanceMain from "../components/ManagerDashboard/Snippet/SnippetLinePerformanceMain";
import SnippetLinePerformanceAv from "../components/ManagerDashboard/Snippet/SnippetLinePerformanceAv";
import SnippetLinePerformancePe from "../components/ManagerDashboard/Snippet/SnippetLinePerformancePe";
import SnippetLinePerformanceQa from "../components/ManagerDashboard/Snippet/SnippetLinePerformanceQa";
import SnippetLinePe from "../components/ManagerDashboard/DashboardRelease/SnippetLinePe";
import GilSupplierDashboard from "../components/ManagerDashboard/DashboardRelease/GilSupplierDashboard";
import GilSqaDashboard from "../components/ManagerDashboard/DashboardRelease/GilSqaDashboard";


import Houdini from "../components/ManagerDashboard/Houdini/TestHoudini_01";
import EmsDashboardConsumption from "../components/ManagerDashboard/DashboardRelease/EmsDashboardConsumption";
import PlantManagerDashboard from "../components/ManagerDashboard/DashboardRelease/PlantManagerDashboard";
import BinTrackDashboard from "../components/ManagerDashboard/DashboardRelease/BinTrackDashboard";




import ImageView from "../components/ImageView/ImageView";
// import ZenContainerKanban from "../components/ManagerDashboard/Common/Containers/ZenContainerKanban";

import ZenContainerAngela from "../components/ManagerDashboard/Common/Containers/ZenContainerAngela";
import LineDashTabSel from "../pages/LineDashboardZen/LineDashTabSel";
import ZenTable from "../components/ManagerDashboard/Common/Table/ZenTable";
import MdashPercentDataOee from "../components/ManagerDashboard/MdashRoutes/MdashPercentDataOee";
import MdashPercentDataDle from "../components/ManagerDashboard/MdashRoutes/MdashPercentDataDle";
import MdashQtyData from "../components/ManagerDashboard/MdashRoutes/MdashQtyData";
import MdashHourData from "../components/ManagerDashboard/MdashRoutes/MdashHourData";
import MdashDownTimeData from "../components/ManagerDashboard/MdashRoutes/MdashDownTime";

import ZenChartArsenal from "../components/ManagerDashboard/ZenChartArsenal";
import ZenChartArsenalTest from "../components/ManagerDashboard/ZenChartArsenalTest";
import ZenChartComboFunction from "../components/ManagerDashboard/ZenChartComboFunction";
import ZenChartMultiFunction from "../components/ManagerDashboard/ZenChartMultiFunction";
import S4MSupplierDashboard from "../components/ManagerDashboard/S4MSupplierDashboard";
import Spc from "../components/Spc/Spc";


// ________________ HXXXoudini_RoutePageImport ______________________
import YiplCarline from "../components/ManagerDashboard/DashboardRelease/YiplCarlineDash";
// import Snippet from "../components/ManagerDashboard/Snippet/Snippet";
import SnippetLineOee from "../components/ManagerDashboard/DashboardRelease/SnippetLineOee";
import ZenChartMultiFunctionMultiApi from "../components/ManagerDashboard/ZenChartMultiFunctionMultiApi";
import DynamicChart from "../pages/DynamicChart";
import ReportTomDynamic from "../pages/ReportTomDynamic";
import YiplCorpDashboardLatest from "../components/ManagerDashboard/DashboardRelease/YiplCorpDashboardFunc";
import GangDie from "../pages/GangDie";
import SnippetForkLift from "../components/ManagerDashboard/DashboardRelease/SnippetForkLift";
import ZenForm from "../pages/ZenForm";
import PhantomPrime from "../pages/PhantomPrime";
import Pharos from "../components/ManagerDashboard/Pharos";
import DynamicZenChart from "../pages/DynamicZenChart";
import ScanterPage from "../pages/ScanterPage";
import SortableList from "../components/SortableList";
import ZenSortableList from "../pages/ZenSortableList";
import PhantomSpecial from "../pages/PhantomSpecial";
import ZenFormMqtt from "../pages/ZenFormMqtt";
import InternalPage from "../pages/InternalPage";
import DraggableStable from "../pages/DraggableStable";
import StAddNew from "../pages/DSeries/StAddNew";
import PCBLoader from "../pages/PCBLoader";
import ZenPopScanter from "../components/ZenPopScanter";
import AutoScanter from "../pages/AutoScanter";
import CreateTask from "../pages/PMS/CreateTask";
import CreateProject from "../pages/PMS/CreateProject";
import SmtPacking from "../pages/SmtPacking";
import CameraComponent from "../components/CameraComponent";
import DynamicScanter from "../pages/DynamicScanter";
import LineDs from "../pages/LineDs";
import RandomDataG from "../pages/RandomDataG";
import ZenFormSegment from "../pages/ZenFormSegment";
const allRoutes = [
  {
    route: "/v02/:urlCode/lineperformance",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <LinePerformance urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  // {
  //   route: "/v02/:urlCode/projecttask",
  //   component: ({ urlData, setPageHeader = () => { } }) => (
  //     <ProjectTasksStable urlData={urlData} setPageHeader={setPageHeader} />
  //   ),
  // },
  {
    route: "/v02/:urlCode/lineperformancecompl",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <Lineperformancecompl urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/linereport",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <LineReport urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },


  {
    route: "/v02/:urlCode/mdash/percentdataoee",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <MdashPercentDataOee urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },

  {
    route: "/v02/:urlCode/mdash/percentdatadle",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <MdashPercentDataDle urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/mdash/qtydata",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <MdashQtyData urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/mdash/hourdata",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <MdashHourData urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },

  {
    route: "/v02/:urlCode/mdash/downtimedata",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <MdashDownTimeData urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },

  {
    route: "/v02/:urlCode/rt/:typ/:subtyp",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <ReportTom urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/zf/:typ/:subtyp",
    component: ({ api, urlData, setPageHeader = () => { } }) => (
      <ZenForm urlEndpoint={api || "/miscellaneous/pageconfig"} urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/zfc",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <CameraComponent urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/zf-mqtt/:typ/:subtyp",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <ZenFormMqtt urlEndpoint={"/miscellaneous/pageconfig"} urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/zfcustom/:typ/:subtyp",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <ZenForm urlEndpoint={"/zfcustom"} urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/qcf/:typ/:subtyp",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <ZenForm urlEndpoint={"/sparktable/miscellaneouspageconfig"} urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/sortable-list",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <SortableList api={'/scm/supplierdocumentmsg'} urlData={{ ...urlData }} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/pcb-loader",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <PCBLoader urlEndpoint={"/sparktable/miscellaneouspageconfig"} urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/ds",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <DynamicScanter api="/ds" urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/line-ds",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <LineDs api="/ds" urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/smt-packing",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <SmtPacking urlEndpoint={"/sparktable/miscellaneouspageconfig"} urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },

  {
    route: "/v02/:urlCode/qcfpageconfig/:typ/:subtyp",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <ZenForm urlEndpoint={"/qcfapproval/pageconfig"} urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },

  {
    route: "/v02/:urlCode/sdf/:typ/:subtyp",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <ZenForm urlEndpoint={"/singledoc/form"} urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },

  {
    route: "/v02/:urlCode/dynamicstable/:typ/:subtyp",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <DynamicStable urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/st",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <DynamicStable url={"/stdtools/phantomzen1"} urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/pp",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <PhantomPrime pageName={"Phantom Prime"} urlEndpoint="/miscellaneous/pageconfig"
        urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },


  {
    route: "/v02/:urlCode/actionRoute",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <PhantomPrime pageName={"Phantom Prime"} urlEndpoint="/actionRoute/miscellaneous/pageconfig"
        urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/scanter",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <ScanterPage
        pageName={"Scanter XYX"}
        urlEndpoint="/textapi"
        urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/auto-scanter",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <AutoScanter
        pageName={"Auto Scanter"}
        method={"POST"}
        api="/smt/scanner"
        urlData={{ ...urlData }} setPageHeader={setPageHeader} />
    ),
  },


  {
    route: "/v02/:urlCode/rt-dyn/:typ/:subtyp",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <ReportTomDynamic urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },

  {
    route: "/v02/:urlCode/yipl/carline",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <YiplCarline urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },




  {
    route: "/v02/:urlCode/sb/sb-line-doh/:typ/:subtyp",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <SbLineDoh urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/sb/sb-line-heizunka-gantt",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <SbLineHeizunkaGantt urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/sb/sb-line-landing-page/:typ/:subtyp",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <SbLineLandingPage urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/sb/sb-part-inp-op-waterfall/:typ/:subtyp",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <SbPartInpOpWaterfall urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/sb/sb-part-landing-page/:typ/:subtyp",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <SbPartLandingPage urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/sb/sb-part-schedule-variation/:typ/:subtyp",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <SbPartScheduleVariation
        urlData={urlData}
        setPageHeader={setPageHeader}
      />
    ),
  },
  {
    route: "/v02/:urlCode/sb/sb-part-stock-movement/:typ/:subtyp",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <SbPartStockMovement urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/sb/sb-plant-landing-page",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <SbPlantLandingPage urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/sb/sb-plant-rog-itr",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <SbPlantRogItr urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },

  ///// ROW COL SPAN IN SbPlantTopVariationParts
  {
    route: "/v02/:urlCode/sb/sb-plant-top-variation-parts",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <SbPlantTopVariationParts
        urlData={urlData}
        setPageHeader={setPageHeader}
      />
    ),
  },
  {
    route: "/v02/:urlCode/zen/table",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <ZenTable urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/internal-report",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <InternalPage urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/format/zentable",
    component: ({ urlData, setPageHeader = () => { } }) => (
      <ZenTable urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/zen/chart",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <ZenSingleChart urlData={urlData} divId={extraData?.divId} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/template/container/single/donut",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <ZenContainerSingleChart
        urlData={urlData}


        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },
  {
    route: "/v02/:urlCode/template/zenchartarsenal",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <ZenChartArsenal
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },
  {
    route: "/v02/:urlCode/template/zenchartarsenaltest",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <ZenChartArsenalTest
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },

  {
    route: "/v02/:urlCode/template/zenchartmultifunction/multiapi",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <ZenChartMultiFunctionMultiApi
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },
  {
    route: "/v02/:urlCode/sortableList",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <ZenSortableList
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },
  {
    route: "/v02/:urlCode/draggable-st",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <DraggableStable
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },
  {
    route: "/v02/:urlCode/phantom-special",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <PhantomSpecial
        urlData={urlData}
        setPageHeader={setPageHeader}
      />
    ),
  },
  {
    route: "/v02/:urlCode/template/zenchartmultifunction/singleapi",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <ZenChartMultiFunction
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },
  {
    route: "/v02/:urlCode/template/zenchartcombofunction",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <ZenChartComboFunction
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },
  {
    route: "/v02/:urlCode/s4m/supplierdashboard",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <S4MSupplierDashboard
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },
  {
    route: "/v02/:urlCode/snippet/lineperformance/main",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <SnippetLinePerformanceMain
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },

  {
    route: "/v02/:urlCode/snippet/lineperformance/av",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <SnippetLinePerformanceAv
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },
  {
    route: "/v02/:urlCode/sn",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <StAddNew
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
        pageName="StAddNew"
        urlEndpoint="/miscellaneous/pageconfig"
      />
    ),
  },

  {
    route: "/v02/:urlCode/sc",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <StAddNew
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
        pageName="StAddNew"
        urlEndpoint="/miscellaneous/pageconfigdynamic"
      />
    ),
  },

  {
    route: "/v02/:urlCode/snippet/lineperformance/pe",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <SnippetLinePerformancePe
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },

  {
    route: "/v02/:urlCode/snippet/lineperformance/qa",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <SnippetLinePerformanceQa
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },

  {
    route: "/v02/:urlCode/spc",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <Spc
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },



  //   <Route
  //   exact
  //   path="/spc"
  //   component={() => <Spc setPageHeader={setPageHeader} />}
  // />




  //   <Route
  //   exact
  //   path="/template/samplecharts"
  //   component={() => <ZenChartTemplate setPageHeader={setPageHeader} />}
  // />

  {
    route: "/v02/:urlCode/taio",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <TaioPage
        pageName={'Taio Page'}
        urlData={urlData}
        urlEndpoint="/miscellaneous/pageconfig"
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },
  {
    route: "/v02/:urlCode/pms/create-task/v2",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <CreateTask
        pageName={'Create Task'}
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },
  {
    route: "/v02/:urlCode/pms/create-project/v2",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <CreateProject
        pageName={'Create Project'}
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },
  {
    route: "/v02/:urlCode/pharos/:typ/:subtyp",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <Pharos
        urlData={urlData}
        urlEndpoint="/miscellaneous/pageconfig"
        dictName="FormatPharosTabs"
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },
  {
    route: "/v02/:urlCode/dc",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <DynamicZenChart
        urlData={urlData}
        setPageHeader={setPageHeader}
      />
    ),
  },


  {
    route: "/v02/:urlCode/template/container/single/angela",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <ZenContainerAngela
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },
  {
    route: "/v02/:urlCode/template/container/zenimage",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <ImageView
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },

  // _______________________________ HXXXoudini ROUTES __________________________________________
  {
    route: "/v02/:urlCode/test/houdini",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <Houdini
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },
  {
    route: "/v02/:urlCode/corp/yipl/dashboard01",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <YiplCorpDashboardLatest
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },





  {
    route: "/v02/:urlCode/ems/consumptiondashboard",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <EmsDashboardConsumption
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },
  {
    route: "/v02/:urlCode/dashboard/plantmanagerdashboard",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <PlantManagerDashboard
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },
  {
    route: "/v02/:urlCode/bt/plantdashboard",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <BinTrackDashboard
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },
  {
    route: "/v02/:urlCode/gil/supplierdashboard",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <GilSupplierDashboard
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },

  {
    route: "/v02/:urlCode/gil/sqadashboard",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <GilSqaDashboard
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },

  {
    route: "/v02/:urlCode/snippet1/snippetlinepe",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <SnippetLinePe
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },
  {
    route: "/v02/:urlCode/snippet1/snippetforklift",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <SnippetForkLift
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },



  {
    route: "/v02/:urlCode/snippet1/snippetlineoee",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <SnippetLineOee
        urlData={urlData}
        divId={extraData?.divId}
        setPageHeader={setPageHeader}
      />
    ),
  },


  // {
  //   route: "/v02/:urlCode/snippetx",
  //   component: ({ urlData, setPageHeader = () => { }, extraData }) => (
  //     <Snippet
  //       urlData={urlData}
  //       divId={extraData?.divId}
  //       setPageHeader={setPageHeader}
  //     />
  //   ),
  // },

  {
    route: "/v02/:urlCode/linedashtabs",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <LineDashTabSel />
    ),
  },
  {
    route: "/v02/:urlCode/dynamic-chart",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <DynamicChart setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/gangdie",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <GangDie setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/random-data-generator",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <RandomDataG urlData={urlData} setPageHeader={setPageHeader} />
    ),
  },
  {
    route: "/v02/:urlCode/zf-segment",
    component: ({ urlData, setPageHeader = () => { }, extraData }) => (
      <ZenFormSegment urlData={urlData} setPageHeader={setPageHeader} />
    ),
  }
];
export default allRoutes;
